import {ADMIN_COMPANY_RESET, ADMIN_COMPANY_SET,ADMIN_COMPANY_CHANGE,
    ADMIN_COMPANY_SETTINGS_CHANGE, ADMIN_COMPANY_ADD_EMAILPRESET} from "../actions/adminCompanyActions";
import {CookiesSettings} from '../helpers/cookiesHelper'
import clone from 'clone'

let cookiesSetting = new CookiesSettings("adminCompany")

let emailsPreset = cookiesSetting.get("emailPreset");
if(!emailsPreset){
    emailsPreset = []
    cookiesSetting.set("emailPreset",emailsPreset)
}


const initialState={
    data:{
        searchUrl: "",
        settings: "",
        companySettings: {
            startHour: 0,
            startMinute: 0,
            alias: "",
            name: "",
            description: "",
            logo: "",
            reportSettings: {
                reportGroup: [],
                startReportHour:0,
                startReportMinute:0

            },
            redmineFolders: [],
            parsingSettings:{
                numberOfTread:0,
                enableHttpRequestsLogging:false,
                offersPortion:0,
                useProxy:false
            }
        },
        id: 0,
        url: "",
        name: "",
        isActive: true,
        shard: 0,
        microMarckup:false,
        sitemap:"",
        isVisible: true,
        demo: ""
    },
    emailsPreset:emailsPreset
}

export default function adminCompany(state=clone(initialState), action){
    let data = action.payload;
    let emailsPreset = state.emailsPreset;
    switch (action.type){
        case ADMIN_COMPANY_SET:
            
        
        if(data.companySettings == null){
                data.companySettings = clone(initialState.data.companySettings)
            }else{
                if(data.companySettings.parsingSettings == null){
                    data.companySettings.parsingSettings = clone(initialState.data.companySettings.parsingSettings)
                }
            }

            return{
                ...state,
                data:data
            }
        case ADMIN_COMPANY_RESET:
            return {...initialState}
        case ADMIN_COMPANY_CHANGE:
            return{
                ...state,
                data:{
                    ...state.data,
                    [action.payload.field]:action.payload.value
                }

            }
        case ADMIN_COMPANY_SETTINGS_CHANGE:
            return{
                ...state,
                data:{
                    ...state.data,
                    companySettings:{
                        ...state.data.companySettings,
                        [action.payload.field]:action.payload.value
                    }
                }
            }
        case ADMIN_COMPANY_ADD_EMAILPRESET:
            if(emailsPreset.indexOf(data) == -1){
                emailsPreset.push(data);
                cookiesSetting.set("emailPreset",emailsPreset)
            }
            return{
                ...state,
                emailsPreset:emailsPreset
            }
        default:{
            return state
        }
    }
}


// WEBPACK FOOTER //
// ./src/reducers/adminCompany.js